var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12.0002 2L14.4698 9.60081H22.4618L15.9962 14.2984L18.4658 21.8992L12.0002 17.2016L5.53456 21.8992L8.00421 14.2984L1.53857 9.60081H9.53054L12.0002 2Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }